import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { dataQualityService, carbonGovernanceService, workflowService } from '../../api/services';

/**
 * Widget de gouvernance (TF-034) sur le tableau de bord : agrège les signaux de confiance des
 * modules Wave 2 — santé des données, couverture carbone, validations en attente — avec un lien
 * direct vers chaque écran. Chaque indicateur se charge indépendamment ; en cas d'accès refusé
 * (rôle sans droit), il est simplement masqué.
 */
export function GovernanceWidget() {
  const [sante, setSante] = useState<number | null>(null);
  const [anomalies, setAnomalies] = useState<number | null>(null);
  const [couverture, setCouverture] = useState<number | null>(null);
  const [validations, setValidations] = useState<number | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    Promise.allSettled([
      dataQualityService.getSummary().then((s) => { setSante(s.scoreSante); setAnomalies(s.total); }),
      carbonGovernanceService.getSummary().then((s) => setCouverture(s.couvertureFacteur)),
      workflowService.getSummary().then((s) => setValidations(s.enAttente)),
    ]).finally(() => setReady(true));
  }, []);

  if (!ready) return null;
  if (sante == null && couverture == null && validations == null) return null;

  const color = (v: number, good: number, mid: number) =>
    v >= good ? 'text-green-600' : v >= mid ? 'text-amber-600' : 'text-red-600';

  return (
    <div className="card">
      <h2 className="font-semibold mb-3">Gouvernance &amp; confiance</h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {sante != null && (
          <Link to="/qualite-donnees" className="block rounded-lg border border-gray-100 p-3 hover:bg-gray-50">
            <p className="text-xs text-gray-500">Santé des données</p>
            <p className={`text-2xl font-bold ${color(sante, 80, 50)}`}>{sante}/100</p>
            {anomalies != null && <p className="text-xs text-gray-400">{anomalies} anomalie(s)</p>}
          </Link>
        )}
        {couverture != null && (
          <Link to="/carbone/gouvernance" className="block rounded-lg border border-gray-100 p-3 hover:bg-gray-50">
            <p className="text-xs text-gray-500">Couverture carbone</p>
            <p className={`text-2xl font-bold ${color(couverture, 80, 50)}`}>{couverture}%</p>
            <p className="text-xs text-gray-400">facteurs d’émission</p>
          </Link>
        )}
        {validations != null && (
          <Link to="/validations" className="block rounded-lg border border-gray-100 p-3 hover:bg-gray-50">
            <p className="text-xs text-gray-500">Validations en attente</p>
            <p className={`text-2xl font-bold ${validations > 0 ? 'text-amber-600' : 'text-green-600'}`}>{validations}</p>
            <p className="text-xs text-gray-400">à traiter</p>
          </Link>
        )}
      </div>
    </div>
  );
}

export default GovernanceWidget;
